export class ModuleTableName{
    constructor(public moduleName: string, public tableName: string){
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/module-table-name.ts